import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { MaterialModule } from "./modules/material.module";
import { SearchSortRoGirdComponent } from "./components/search-sort-ro-gird/search-sort-ro-gird.component";
import { TranslateModule } from "@ngx-translate/core";
import { CastPipe } from "./pipes/cast/cast.pipe";
import { FpxSelectableDropdownComponent } from "./components/fpx-selectable-dropdown/fpx-selectable-dropdown.component";
import { FpxLabelComponent } from "./components/fpx-label/fpx-label.component";
import { FpxTextBoxComponent } from "./components/fpx-text-box/text-box.component";
import { FpxRadioButtonComponent } from "./components/fpx-radio-button/fpx-radio-button.component";
import { BoxComponent } from "./components/box/box.component";
import { FpxDateComponent } from "./components/fpx-date/fpx-date.component";
import { FpxTextAreaComponent } from './components/fpx-text-area/fpx-text-area.component';
import { FpxRoGridComponent } from "./components/fpx-ro-grid/fpx-ro-grid.component";
import { FpxAmountComponent } from "./components/fpx-amount/fpx-amount.component";
import { NgxMaskModule } from "ngx-mask";
import { FpxAmountSliderComponent } from "./components/fpx-amount-slider/fpx-amount-slider.component";
import { FpxSwitchComponent } from "./components/fpx-switch/fpx-switch.component";
import { MatIconModule } from "@angular/material/icon";
import { FpxHiddenComponent } from "./components/fpx-hidden/fpx-hidden.component";
import { FpxPhotoCaptureComponent } from "./components/fpx-photo-capture/fpx-photo-capture.component";
import { FpxVideoCaptureComponent } from "./components/fpx-video-capture/fpx-video-capture.component";
import { FpxTimerComponent } from "./components/fpx-timer/fpx-timer.component";
import { FpxPinComponent } from "./components/fpx-pin/fpx-pin.component";
import { FpxPasswordComponent } from "./components/fpx-password/fpx-password.component";
import { FpxButtonComponent } from "./components/fpx-button/fpx-button.component";
import { FpxNumberComponent } from "./components/fpx-number/fpx-number.component";
import { FpxCarouselComponent } from "./components/fpx-carousel/fpx-carousel.component";
import { SlickCarouselModule } from "ngx-slick-carousel";
import { SafeHtmlPipe } from "./pipes/safe-html/safe-html.pipe";
import { AlertDialogComponent } from "./dialogs/alert-dialog/alert-dialog.component";
import { ConfirmationDialogComponent } from "./dialogs/confirmation-dialog/confirmation-dialog.component";
import { FpxDynamicFormComponent } from "./components/fpx-dynamic-form/fpx-dynamic-form.component";
import { FpxCheckboxComponent } from "./components/fpx-checkbox/fpx-checkbox.component";
import { FpxClickDbclickDirective } from "./directives/click-dbclick.directive";
import { FpxDisplayTextComponent } from './components/fpx-display-text/fpx-display-text.component';
import { ErrorAnchorDirective, FpxFormAnchorDirective } from "./directives/error-handler/error-container.directive";
import { FpxFileUploadComponent } from "./components/fpx-file-upload/fpx-file-upload.component";
import { CbxSwipeDirective } from "./components/fpx-swipe/fpx-swipe.directive";
import { OnlineOfflineDialogComponent } from "./dialogs/online-offline-dialog/online-offline-dialog.component";
import { DebounceClickDirective } from "./directives/debounce-click.directive";

@NgModule({
  declarations: [
    CastPipe,
    FpxSelectableDropdownComponent,
    FpxLabelComponent,
    FpxTextBoxComponent,
    FpxRadioButtonComponent,
    SearchSortRoGirdComponent,
    BoxComponent,
    FpxDateComponent,
    FpxTextAreaComponent,
    FpxRoGridComponent,
    FpxAmountComponent,
    FpxAmountSliderComponent,
    FpxHiddenComponent,
    FpxSwitchComponent,
    FpxPhotoCaptureComponent,
    FpxVideoCaptureComponent,
    FpxTimerComponent,
    FpxPinComponent,
    FpxPasswordComponent,
    FpxButtonComponent,
    FpxNumberComponent,
    FpxCarouselComponent,
    SafeHtmlPipe,
    FpxRoGridComponent,
    AlertDialogComponent,
    ConfirmationDialogComponent,
    FpxDynamicFormComponent,
    FpxCheckboxComponent,
    FpxClickDbclickDirective,
    FpxDisplayTextComponent,
    FpxFormAnchorDirective,
    ErrorAnchorDirective,
    FpxFileUploadComponent,
    CbxSwipeDirective,
    OnlineOfflineDialogComponent,
    DebounceClickDirective
  ],
  imports: [
    ReactiveFormsModule,
    FormsModule,
    CommonModule,
    MaterialModule,
    TranslateModule,
    NgxMaskModule,
    MatIconModule,
    SlickCarouselModule
  ],
  exports: [
    FpxSelectableDropdownComponent,
    FpxLabelComponent,
    FpxTextBoxComponent,
    FpxRadioButtonComponent,
    BoxComponent,
    FpxDateComponent,
    FpxTextAreaComponent,
    FpxRoGridComponent,
    FpxAmountComponent,
    FpxAmountSliderComponent,
    FpxHiddenComponent,
    FpxSwitchComponent,
    FpxPhotoCaptureComponent,
    FpxVideoCaptureComponent,
    FpxTimerComponent,
    FpxPinComponent,
    FpxPasswordComponent,
    FpxButtonComponent,
    FpxNumberComponent,
    FpxCarouselComponent,
    SafeHtmlPipe,
    FpxRoGridComponent,
    AlertDialogComponent,
    ConfirmationDialogComponent,
    FpxDynamicFormComponent,
    FpxCheckboxComponent,
    FpxClickDbclickDirective,
    FpxDisplayTextComponent,
    FpxFormAnchorDirective,
    ErrorAnchorDirective,
    FpxFileUploadComponent,
    CbxSwipeDirective,
    OnlineOfflineDialogComponent,
    DebounceClickDirective
  ],
})
export class FpxCoreModule {}
